"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ThreeCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThreeCircleLinear = function ThreeCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.396 20.188c1.067-1.126 2.578-1.699 4.402-1.699 1.802 0 3.309.553 4.366 1.606 1.058 1.053 1.612 2.552 1.612 4.339 0 1.436-.368 2.701-1.079 3.67a4.547 4.547 0 01-1.46 1.294c.78.338 1.445.838 1.969 1.481.848 1.04 1.296 2.42 1.296 4.016 0 2.07-.654 3.82-1.853 5.055-1.2 1.237-2.905 1.913-4.917 1.913-1.9 0-3.514-.654-4.647-1.837-1.132-1.182-1.744-2.85-1.727-4.805a.5.5 0 01.5-.496h1.254a.5.5 0 01.5.47c.094 1.581.525 2.726 1.206 3.471.67.734 1.639 1.141 2.947 1.141 1.381 0 2.48-.475 3.235-1.288.759-.817 1.215-2.023 1.215-3.558 0-1.522-.433-2.609-1.201-3.321-.775-.718-1.97-1.129-3.645-1.129h-.001c-.192 0-.407 0-.782.031a.5.5 0 01-.542-.498v-1.089a.5.5 0 01.55-.497c.305.03.45.03.742.03 1.459 0 2.477-.36 3.13-.99.651-.627 1.023-1.598 1.023-2.998 0-1.313-.362-2.29-.97-2.937-.603-.642-1.508-1.018-2.721-1.018-1.217 0-2.145.409-2.783 1.12-.646.72-1.042 1.806-1.073 3.242a.5.5 0 01-.5.489h-1.221a.5.5 0 01-.5-.513c.052-1.966.615-3.574 1.675-4.695z",
    fill: "url(#ThreeCircleLinear_svg__ThreeCircleLinear_svg__paint0_linear_17373_95586)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 30c0 16.569-13.431 30-30 30C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30zm-2 0c0 15.464-12.536 28-28 28S2 45.464 2 30 14.536 2 30 2s28 12.536 28 28z",
    fill: "url(#ThreeCircleLinear_svg__ThreeCircleLinear_svg__paint1_linear_17373_95586)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ThreeCircleLinear_svg__ThreeCircleLinear_svg__paint0_linear_17373_95586",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ThreeCircleLinear_svg__ThreeCircleLinear_svg__paint1_linear_17373_95586",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.ThreeCircleLinear = ThreeCircleLinear;
var _default = ThreeCircleLinear;
exports.default = _default;